export const delay = (ms: number): Promise<number> =>
    new Promise<number>(function (resolve) {
        setTimeout(() => resolve(ms), ms)
    })

export const discardResult = (promise: Promise<unknown>): Promise<void> => promise.then(() => {})

export const promiseAny = <T>(promises: Promise<T>[]): Promise<T> => {
    const errors: unknown[] = []

    return new Promise<T>((resolve, reject) => {
        promises.forEach((promise) => {
            promise
                .then((value: T) => resolve(value))
                .catch((error?: unknown) => {
                    errors.push(error)
                    if (errors.length === promises.length) reject(errors)
                })
        })
    })
}
